// extracted by mini-css-extract-plugin
export default {"preview":"styles_preview__l4bif","preview_big":"styles_preview_big__b9QJ7","wrapper":"styles_wrapper__PjwC7"};